import { makeStyles } from '@mui/styles'
import { alpha } from '@mui/material'

export const useCommentListItemStyles = makeStyles((theme) => ({
    container: {},
    minimizedContainer: {
        borderBottom: '0.5px solid',
        borderBottomColor: theme.palette.figma.grayscale.stroke,
        '&:last-of-type': {
            borderBottom: 'unset',
        },
    },
    innerContainer: {
        backgroundColor: `${theme.palette.figma.grayscale.contentWrapper} !important`,
        width: '85%',
        padding: theme.spacing(2),
        borderRadius: `${theme.spacing(2)} !important`,
        position: 'relative',
    },
    resolved: {
        backgroundColor: `${alpha(theme.palette.figma.accentColors.green, 0.1)} !important`,
        borderLeftColor: theme.palette.figma.accentColors.green,
    },
    minimizedInnerContainer: {
        width: '100%',
        padding: theme.spacing(1),
        borderRadius: 'unset !important',
    },
    text: {
        color: theme.palette.figma.grayscale.textHier2,
        paddingRight: theme.spacing(4.5),
        paddingBottom: theme.spacing(2),
    },
    minimizedText: {
        marginLeft: theme.spacing(4.5),
    },
    date: {
        color: `${theme.palette.figma.grayscale.textHier2} !important`,
    },
    author: {
        flexGrow: 1,
        color: theme.palette.figma.grayscale.textHier1,
    },
    minimizedAuthor: {
        flexGrow: 'unset',
    },
    avatar: {
        height: `${theme.spacing(3)} !important`,
        width: `${theme.spacing(3)} !important`,
        fontSize: '12px !important',
        fontWeight: '600 !important',
        color: `${theme.palette.figma.accentColors.white} !important`,
    },
    avatarWrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    resolvedAvatarBadge: {
        position: 'absolute',
        right: -3,
        bottom: -3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: theme.spacing(1.75),
        height: theme.spacing(1.75),
        borderRadius: '50%',
        backgroundColor: theme.palette.figma.accentColors.green,
        color: theme.palette.figma.accentColors.white,
        boxShadow: `0 0 0 2px ${theme.palette.figma.grayscale.contentWrapper}`,
    },
    resolvedAvatarIcon: {
        fontSize: `${theme.spacing(1.25)} !important`,
    },
    actionsAnchor: {
        position: 'absolute',
        right: theme.spacing(1),
        bottom: theme.spacing(1),
    },
    menuAnchor: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
    },
    actionIndicatorButton: {
        padding: `${theme.spacing(0.5)} !important`,
        color: `${theme.palette.figma.primary} !important`,
        '&:hover': {
            color: `${theme.palette.figma.primary} !important`,
        },
    },
}))
